
// import React from 'react';
// import { Link } from 'react-router-dom';
// import { useLocation } from '../../context/LocationContext';

// const Footer = () => {
//   const { maharashtraLocations } = useLocation();

//   const footerStyle = {
//     background: `linear-gradient(rgba(6, 95, 70, 0.95), rgba(6, 95, 70, 0.95)), url('/images/footer-bg.jpg') center/cover no-repeat`,
//     color: 'white',
//     padding: '40px 15px 20px',
//     position: 'relative',
//     fontFamily: "Cambria, serif",
//     width: '100%',
//     boxSizing: 'border-box'
//   };

//   const containerStyle = {
//     maxWidth: '1200px',
//     margin: '0 auto',
//     position: 'relative',
//     zIndex: '2',
//     width: '100%',
//     boxSizing: 'border-box'
//   };

//   const footerContainerStyle = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(4, 1fr)',
//     gap: '30px',
//     marginBottom: '30px'
//   };

//   const footerSectionStyle = {
//     marginBottom: '0'
//   };

//   const footerSectionTitleStyle = {
//     fontSize: '18px',
//     fontWeight: '700',
//     marginBottom: '20px',
//     color: '#fff',
//     textTransform: 'uppercase',
//     letterSpacing: '1px',
//     borderBottom: '2px solid #10B981',
//     paddingBottom: '10px',
//     display: 'inline-block'
//   };

//   const footerTextStyle = {
//     fontSize: '14px',
//     lineHeight: '1.6',
//     marginBottom: '20px',
//     color: '#d1fae5'
//   };

//   const footerLinksStyle = {
//     listStyle: 'none',
//     padding: '0',
//     margin: '0'
//   };

//   const footerLinkStyle = {
//     color: '#d1fae5',
//     textDecoration: 'none',
//     fontSize: '14px',
//     lineHeight: '2',
//     display: 'block',
//     fontWeight: '500',
//     padding: '5px 0',
//     transition: 'all 0.3s ease'
//   };

//   const linkHoverStyle = {
//     color: '#34D399',
//     transform: 'translateX(5px) scale(0.95)',
//     fontWeight: '600'
//   };

//   const contactInfoStyle = {
//     marginTop: '10px'
//   };

//   const contactItemStyle = {
//     fontSize: '14px',
//     lineHeight: '1.8',
//     color: '#d1fae5',
//     marginBottom: '8px',
//     display: 'flex',
//     alignItems: 'flex-start',
//     fontWeight: '500'
//   };

//   const footerBottomStyle = {
//     borderTop: '1px solid rgba(255, 255, 255, 0.1)',
//     paddingTop: '20px',
//     textAlign: 'center',
//     fontSize: '14px',
//     color: '#a7f3d0',
//     width: '100%',
//     boxSizing: 'border-box'
//   };

//   const socialIconStyle = {
//     color: '#d1fae5',
//     fontSize: '18px',
//     textDecoration: 'none',
//     fontWeight: '500',
//     transition: 'all 0.3s ease',
//     display: 'inline-block',
//     width: '35px',
//     height: '35px',
//     textAlign: 'center',
//     lineHeight: '35px',
//     borderRadius: '50%',
//     backgroundColor: 'rgba(255, 255, 255, 0.1)'
//   };

//   const socialHoverStyle = {
//     color: '#34D399',
//     backgroundColor: 'rgba(52, 211, 153, 0.2)',
//     transform: 'scale(0.9)'
//   };

//   const createLink = (to, text) => (
//     <li>
//       <Link 
//         to={to} 
//         style={footerLinkStyle}
//         onMouseEnter={(e) => {
//           e.target.style.color = linkHoverStyle.color;
//           e.target.style.transform = linkHoverStyle.transform;
//           e.target.style.fontWeight = linkHoverStyle.fontWeight;
//         }}
//         onMouseLeave={(e) => {
//           e.target.style.color = footerLinkStyle.color;
//           e.target.style.transform = 'none';
//           e.target.style.fontWeight = footerLinkStyle.fontWeight;
//         }}
//       >
//         {text}
//       </Link>
//     </li>
//   );

//   return (
//     <>
//       <style>
//         {`
//           @media (max-width: 1024px) {
//             .footer-container {
//               grid-template-columns: repeat(2, 1fr) !important;
//               gap: 40px 30px !important;
//             }
            
//             .footer-section {
//               margin-bottom: 20px !important;
//             }
            
//             .footer-section-title {
//               font-size: 16px !important;
//             }
            
//             .contact-item {
//               font-size: 13px !important;
//               line-height: 1.6 !important;
//             }
            
//             .social-icons {
//               justify-content: flex-start !important;
//             }
//           }
          
//           @media (max-width: 768px) {
//             .footer-container {
//               grid-template-columns: 1fr !important;
//               gap: 30px !important;
//             }
            
//             .footer-section {
//               text-align: center !important;
//             }
            
//             .footer-section-title {
//               font-size: 15px !important;
//               text-align: center !important;
//               width: 100% !important;
//             }
            
//             .footer-links {
//               text-align: center !important;
//             }
            
//             .footer-link {
//               text-align: center !important;
//               padding: 8px 0 !important;
//             }
            
//             .contact-info {
//               text-align: center !important;
//             }
            
//             .contact-item {
//               justify-content: center !important;
//               text-align: center !important;
//               font-size: 12px !important;
//             }
            
//             .social-icons {
//               justify-content: center !important;
//               gap: 10px !important;
//             }
            
//             .social-icon {
//               width: 32px !important;
//               height: 32px !important;
//               line-height: 32px !important;
//               font-size: 16px !important;
//             }
            
//             .footer-bottom {
//               font-size: 12px !important;
//               padding-top: 15px !important;
//             }
            
//             .footer-bottom p {
//               font-size: inherit !important;
//               margin: 5px 0 !important;
//             }
//           }
          
//           @media (max-width: 480px) {
//             .footer {
//               padding: 30px 10px 15px !important;
//             }
            
//             .footer-container {
//               gap: 25px !important;
//             }
            
//             .footer-section-title {
//               font-size: 14px !important;
//               padding-bottom: 8px !important;
//               margin-bottom: 15px !important;
//             }
            
//             .footer-text {
//               font-size: 13px !important;
//               line-height: 1.5 !important;
//             }
            
//             .footer-link {
//               font-size: 13px !important;
//               padding: 6px 0 !important;
//             }
            
//             .contact-item {
//               font-size: 11px !important;
//               line-height: 1.5 !important;
//               margin-bottom: 6px !important;
//               flex-wrap: wrap !important;
//             }
            
//             .social-icon {
//               width: 30px !important;
//               height: 30px !important;
//               line-height: 30px !important;
//               font-size: 14px !important;
//             }
            
//             .footer-bottom {
//               font-size: 11px !important;
//             }
//           }
          
//           /* Touch-friendly styles */
//           @media (hover: none) and (pointer: coarse) {
//             .footer-link:hover,
//             .social-icon:hover {
//               transform: none !important;
//             }
//           }
          
//           /* Prevent text selection on mobile */
//           @media (max-width: 768px) {
//             .footer-link {
//               -webkit-tap-highlight-color: transparent;
//               user-select: none;
//             }
//           }
          
//           /* Improve spacing for mobile */
//           .footer-link {
//             min-height: 30px;
//             display: flex;
//             align-items: center;
//             justify-content: flex-start;
//           }
          
//           @media (max-width: 768px) {
//             .footer-link {
//               justify-content: center;
//             }
//           }
//         `}
//       </style>
      
//       <footer className="footer" style={footerStyle}>
//         <div style={containerStyle}>
//           <div className="footer-container" style={footerContainerStyle}>
//             {/* About Us Section */}
//             <div className="footer-section" style={footerSectionStyle}>
//               <h3 className="footer-section-title" style={footerSectionTitleStyle}>ABOUT US</h3>
//               <p style={footerTextStyle}>
//                 At Blue Sky Energy, we bring over 5+ years of experience in general contracting, electrical work, and solar installations for homes, businesses, and larger commercial projects.
//               </p>
//               <ul style={footerLinksStyle}>
//                 {createLink("/about", "Our Heritage")}
//                 {createLink("/vision", "Vision Mission & Values")}
//                 {createLink("/milestones", "Company Milestones")}
//                 {createLink("/awards", "Awards & Recognition")}
//               </ul>
//             </div>

//             {/* Solar Solutions & Locations */}
//             <div className="footer-section" style={footerSectionStyle}>
//               <h3 className="footer-section-title" style={footerSectionTitleStyle}>SOLAR SOLUTIONS</h3>
//               <ul style={footerLinksStyle}>
//                 {createLink("/solar-pumps", "Solar Water Pumps")}
//                 {createLink("/rooftop", "Rooftop Solar")}
//                 {createLink("/projects", "Large Projects")}
//                 {createLink("/manufacturing", "Manufacturing Edge")}
//               </ul>
              
//               <h3 className="footer-section-title" style={{...footerSectionTitleStyle, marginTop: '30px'}}>OUR LOCATIONS</h3>
//               <ul style={footerLinksStyle}>
//                 {maharashtraLocations.slice(0, 11).map(location => (
//                   <li key={location.id}>
//                     <Link 
//                       to={`/location/${location.id}`} 
//                       className="footer-link"
//                       style={footerLinkStyle}
//                       onMouseEnter={(e) => {
//                         e.target.style.color = linkHoverStyle.color;
//                         e.target.style.transform = linkHoverStyle.transform;
//                         e.target.style.fontWeight = linkHoverStyle.fontWeight;
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.color = footerLinkStyle.color;
//                         e.target.style.transform = 'none';
//                         e.target.style.fontWeight = footerLinkStyle.fontWeight;
//                       }}
//                     >
//                       {location.name}
//                     </Link>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Quick Links & Sustainability */}
//             <div className="footer-section" style={footerSectionStyle}>
//               <h3 className="footer-section-title" style={footerSectionTitleStyle}>QUICK LINKS</h3>
//               <ul style={footerLinksStyle}>
//                 {createLink("/", "Home")}
//                 {createLink("/residential", "Residential")}
//                 {createLink("/commercial", "Commercial & Industrial")}
//                 {createLink("/case-studies", "Case Studies")}
//                 {createLink("/media", "Media Gallery")}
//               </ul>

//               <h3 className="footer-section-title" style={{...footerSectionTitleStyle, marginTop: '30px'}}>SUSTAINABILITY</h3>
//               <ul style={footerLinksStyle}>
//                 {createLink("/environment", "Environmental Compliance")}
//                 {createLink("/hse", "Health, Safety & Environment")}
//                 {createLink("/csr", "Corporate Social Responsibility")}
//               </ul>
//             </div>

//             {/* Contact & Social */}
//             <div className="footer-section" style={footerSectionStyle}>
//               <h3 className="footer-section-title" style={footerSectionTitleStyle}>CONTACT US</h3>
//               <div className="contact-info" style={contactInfoStyle}>
//                 <p className="contact-item" style={contactItemStyle}>
//                   <span style={{marginRight: '10px', fontWeight: '600', flexShrink: '0'}}>📞</span> 
//                   <span>+91 80879 32436</span>
//                 </p>
//                 <p className="contact-item" style={contactItemStyle}>
//                   <span style={{marginRight: '10px', fontWeight: '600', flexShrink: '0'}}>✉️</span> 
//                   <span>info@greenlifesolution.in</span>
//                 </p>
//                 <p className="contact-item" style={contactItemStyle}>
//                   <span style={{marginRight: '10px', fontWeight: '600', flexShrink: '0'}}>🏢</span> 
//                   <span>Plot.No 62A, Umred Rd, Satyam nagar, dighori, Bahadura, Nagpur, Maharashtra 440034</span>
//                 </p>
//                 <p className="contact-item" style={contactItemStyle}>
//                   <span style={{marginRight: '10px', fontWeight: '600', flexShrink: '0'}}>⏰</span> 
//                   <span>Mon-Sun: 9:00 AM - 7:00 PM</span>
//                 </p>
//               </div>

//               <h3 className="footer-section-title" style={{...footerSectionTitleStyle, marginTop: '30px'}}>FOLLOW US</h3>
//               <div className="social-icons" style={{display: 'flex', gap: '15px', marginTop: '15px', flexWrap: 'wrap'}}>
//                 {['X', 'f', 'in', '💷', '💸'].map((icon, index) => (
//                   <a 
//                     key={index}
//                     href="#" 
//                     className="social-icon"
//                     style={socialIconStyle}
//                     onMouseEnter={(e) => {
//                       e.target.style.color = socialHoverStyle.color;
//                       e.target.style.transform = socialHoverStyle.transform;
//                       e.target.style.backgroundColor = socialHoverStyle.backgroundColor;
//                     }}
//                     onMouseLeave={(e) => {
//                       e.target.style.color = socialIconStyle.color;
//                       e.target.style.transform = 'none';
//                       e.target.style.backgroundColor = socialIconStyle.backgroundColor;
//                     }}
//                   >
//                     {icon}
//                   </a>
//                 ))}
//               </div>
//             </div>
//           </div>

//           <div className="footer-bottom" style={footerBottomStyle}>
//             <p style={{fontWeight: '500', margin: '0 0 10px 0'}}>Legal Disclaimer | Privacy Policy | Terms of Use</p>
//             <p style={{margin: '5px 0', fontSize: '13px', fontWeight: '500'}}>
//               Blue Sky Energies 2025 Nagpur | Solar Panel Installation in Nagpur |
//               Maharashtra Solar Solutions
//             </p>
//             <p style={{margin: '5px 0', fontSize: '15px', fontWeight: '550'}}>
//               Copyright © 2025 KARMIC NEXUS IOT & IT COMPANY
//             </p>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// };

// export default Footer;























// components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from '../../context/LocationContext';

const Footer = () => {
  const { maharashtraLocations } = useLocation();

  // Color Palette
  const colors = {
    deepTeal: '#061221',
    darkNavy: '#123249',
    midnight: '#2D5A74',
    slate: '#447793',
    frost: '#DDE8ED',
    white: '#ffffff',
    gradient: 'linear-gradient(135deg, #447793 0%, #2D5A74 100%)',
    gradientHover: 'linear-gradient(135deg, #2D5A74 0%, #123249 100%)'
  };

  const footerStyle = {
    background: `linear-gradient(135deg, ${colors.deepTeal} 0%, ${colors.darkNavy} 100%)`,
    color: colors.white,
    padding: '60px 15px 20px',
    position: 'relative',
    fontFamily: "Cambria, serif",
    width: '100%',
    boxSizing: 'border-box',
    borderTop: `4px solid ${colors.slate}`,
    boxShadow: '0 -10px 30px rgba(6, 18, 33, 0.1)'
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    position: 'relative',
    zIndex: '2',
    width: '100%',
    boxSizing: 'border-box'
  };

  const footerContainerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '30px',
    marginBottom: '40px'
  };

  const footerSectionStyle = {
    marginBottom: '0'
  };

  const footerSectionTitleStyle = {
    fontSize: '18px',
    fontWeight: '700',
    marginBottom: '20px',
    color: colors.frost,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    borderBottom: `2px solid ${colors.slate}`,
    paddingBottom: '10px',
    display: 'inline-block'
  };

  const footerTextStyle = {
    fontSize: '14px',
    lineHeight: '1.6',
    marginBottom: '20px',
    color: colors.frost,
    opacity: '0.9'
  };

  const footerLinksStyle = {
    listStyle: 'none',
    padding: '0',
    margin: '0'
  };

  const footerLinkStyle = {
    color: colors.frost,
    textDecoration: 'none',
    fontSize: '14px',
    lineHeight: '2',
    display: 'block',
    fontWeight: '500',
    padding: '5px 0',
    transition: 'all 0.3s ease',
    opacity: '0.9'
  };

  const linkHoverStyle = {
    color: colors.white,
    transform: 'translateX(5px)',
    fontWeight: '600',
    opacity: '1'
  };

  const contactInfoStyle = {
    marginTop: '10px'
  };

  const contactItemStyle = {
    fontSize: '14px',
    lineHeight: '1.8',
    color: colors.frost,
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'flex-start',
    fontWeight: '500',
    opacity: '0.9'
  };

  const footerBottomStyle = {
    borderTop: `1px solid ${colors.midnight}`,
    paddingTop: '25px',
    textAlign: 'center',
    fontSize: '14px',
    color: colors.frost,
    width: '100%',
    boxSizing: 'border-box'
  };

  const socialIconStyle = {
    color: colors.frost,
    fontSize: '18px',
    textDecoration: 'none',
    fontWeight: '500',
    transition: 'all 0.3s ease',
    display: 'inline-block',
    width: '38px',
    height: '38px',
    textAlign: 'center',
    lineHeight: '38px',
    borderRadius: '50%',
    backgroundColor: colors.midnight,
    border: `1px solid ${colors.slate}`,
    opacity: '0.9'
  };

  const socialHoverStyle = {
    color: colors.white,
    backgroundColor: colors.slate,
    transform: 'translateY(-3px)',
    opacity: '1',
    boxShadow: '0 5px 15px rgba(68, 119, 147, 0.3)'
  };

  const createLink = (to, text) => (
    <li key={to}>
      <Link 
        to={to} 
        style={footerLinkStyle}
        onMouseEnter={(e) => {
          e.target.style.color = linkHoverStyle.color;
          e.target.style.transform = linkHoverStyle.transform;
          e.target.style.fontWeight = linkHoverStyle.fontWeight;
          e.target.style.opacity = linkHoverStyle.opacity;
        }}
        onMouseLeave={(e) => {
          e.target.style.color = footerLinkStyle.color;
          e.target.style.transform = 'none';
          e.target.style.fontWeight = footerLinkStyle.fontWeight;
          e.target.style.opacity = footerLinkStyle.opacity;
        }}
      >
        {text}
      </Link>
    </li>
  );

  // Responsive styles based on window width
  const getResponsiveStyles = () => {
    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      
      if (width <= 480) {
        return {
          container: { ...footerContainerStyle, gridTemplateColumns: '1fr', gap: '25px' },
          title: { ...footerSectionTitleStyle, fontSize: '16px', textAlign: 'center', width: '100%' },
          link: { ...footerLinkStyle, textAlign: 'center', justifyContent: 'center' },
          contact: { ...contactItemStyle, justifyContent: 'center', textAlign: 'center', fontSize: '13px' },
          social: { justifyContent: 'center' }
        };
      } else if (width <= 768) {
        return {
          container: { ...footerContainerStyle, gridTemplateColumns: '1fr', gap: '30px' },
          title: { ...footerSectionTitleStyle, fontSize: '17px', textAlign: 'center', width: '100%' },
          link: { ...footerLinkStyle, textAlign: 'center', justifyContent: 'center' },
          contact: { ...contactItemStyle, justifyContent: 'center', textAlign: 'center', fontSize: '13px' },
          social: { justifyContent: 'center' }
        };
      } else if (width <= 1024) {
        return {
          container: { ...footerContainerStyle, gridTemplateColumns: 'repeat(2, 1fr)', gap: '40px 30px' },
          title: { ...footerSectionTitleStyle, fontSize: '17px' },
          link: { ...footerLinkStyle, fontSize: '13px' },
          contact: { ...contactItemStyle, fontSize: '13px' }
        };
      }
    }
    return {
      container: footerContainerStyle,
      title: footerSectionTitleStyle,
      link: footerLinkStyle,
      contact: contactItemStyle
    };
  };

  const responsiveStyles = getResponsiveStyles();

  return (
    <>
      <style>{`
        @media (max-width: 1024px) {
          .footer-section {
            text-align: left;
          }
          .social-icons {
            justify-content: flex-start !important;
          }
        }
        
        @media (max-width: 768px) {
          .footer-section {
            text-align: center !important;
          }
          .footer-section-title {
            text-align: center !important;
            width: 100% !important;
          }
          .footer-link {
            justify-content: center !important;
            text-align: center !important;
          }
          .contact-item {
            justify-content: center !important;
            flex-wrap: wrap !important;
          }
          .social-icons {
            justify-content: center !important;
          }
        }
        
        @media (max-width: 480px) {
          .footer {
            padding: 40px 12px 15px !important;
          }
          .footer-section-title {
            font-size: 15px !important;
          }
          .footer-text {
            font-size: 13px !important;
          }
          .footer-link {
            font-size: 13px !important;
            padding: 6px 0 !important;
          }
          .contact-item {
            font-size: 12px !important;
            line-height: 1.5 !important;
          }
          .social-icon {
            width: 35px !important;
            height: 35px !important;
            line-height: 35px !important;
            font-size: 16px !important;
          }
        }
        
        @media (max-width: 360px) {
          .footer {
            padding: 30px 10px 15px !important;
          }
          .footer-section-title {
            font-size: 14px !important;
          }
          .footer-link {
            font-size: 12px !important;
          }
          .contact-item {
            font-size: 11px !important;
            flex-direction: column !important;
            align-items: center !important;
          }
          .contact-item span:first-child {
            margin-bottom: 5px !important;
          }
        }
        
        /* Touch device optimizations */
        @media (hover: none) and (pointer: coarse) {
          .footer-link:hover,
          .social-icon:hover {
            transform: none !important;
          }
          .footer-link:active,
          .social-icon:active {
            opacity: 0.8;
          }
        }
        
        /* Smooth transitions */
        .footer-link {
          transition: all 0.3s ease;
        }
        
        .social-icon {
          transition: all 0.3s ease;
        }
        
        /* Prevent text selection on mobile */
        @media (max-width: 768px) {
          .footer-link,
          .social-icon {
            -webkit-tap-highlight-color: transparent;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
          }
        }
        
        /* Better spacing for mobile */
        .footer-link {
          min-height: 36px;
          display: flex;
          align-items: center;
        }
        
        .contact-item {
          word-break: break-word;
        }
        
        /* Decorative elements */
        .footer::before {
          content: '☀️';
          position: absolute;
          top: 30px;
          right: 30px;
          font-size: 60px;
          opacity: 0.1;
          transform: rotate(15deg);
          pointer-events: none;
        }
        
        .footer::after {
          content: '⚡';
          position: absolute;
          bottom: 30px;
          left: 30px;
          font-size: 50px;
          opacity: 0.1;
          transform: rotate(-15deg);
          pointer-events: none;
        }
        
        @media (max-width: 768px) {
          .footer::before,
          .footer::after {
            font-size: 40px;
            opacity: 0.05;
          }
          .footer::before {
            top: 20px;
            right: 20px;
          }
          .footer::after {
            bottom: 20px;
            left: 20px;
          }
        }
        
        @media (max-width: 480px) {
          .footer::before,
          .footer::after {
            display: none;
          }
        }
      `}</style>
      
      <footer className="footer" style={footerStyle}>
        <div style={containerStyle}>
          <div className="footer-container" style={responsiveStyles.container}>
            {/* About Us Section */}
            <div className="footer-section" style={footerSectionStyle}>
              <h3 className="footer-section-title" style={responsiveStyles.title}>ABOUT US</h3>
              <p style={footerTextStyle}>
                At Blue Sky Energy, we bring over 5+ years of experience in solar installations for homes, businesses, and larger commercial projects across Maharashtra.
              </p>
              <ul style={footerLinksStyle}>
                {createLink("/about", "Our Heritage")}
                {createLink("/vision", "Vision Mission & Values")}
                {createLink("/milestones", "Company Milestones")}
                {createLink("/awards", "Awards & Recognition")}
              </ul>
            </div>

            {/* Solar Solutions & Locations */}
            <div className="footer-section" style={footerSectionStyle}>
              <h3 className="footer-section-title" style={responsiveStyles.title}>SOLAR SOLUTIONS</h3>
              <ul style={footerLinksStyle}>
                {createLink("/solar-pumps", "Solar Water Pumps")}
                {createLink("/rooftop", "Rooftop Solar")}
                {createLink("/projects", "Large Projects")}
                {createLink("/manufacturing", "Manufacturing Edge")}
              </ul>
              
              <h3 className="footer-section-title" style={{...responsiveStyles.title, marginTop: '30px'}}>OUR LOCATIONS</h3>
              <ul style={footerLinksStyle}>
                {maharashtraLocations.slice(0, 11).map(location => (
                  <li key={location.id}>
                    <Link 
                      to={`/location/${location.id}`} 
                      className="footer-link"
                      style={responsiveStyles.link}
                      onMouseEnter={(e) => {
                        e.target.style.color = linkHoverStyle.color;
                        e.target.style.transform = linkHoverStyle.transform;
                        e.target.style.fontWeight = linkHoverStyle.fontWeight;
                        e.target.style.opacity = linkHoverStyle.opacity;
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.color = footerLinkStyle.color;
                        e.target.style.transform = 'none';
                        e.target.style.fontWeight = footerLinkStyle.fontWeight;
                        e.target.style.opacity = footerLinkStyle.opacity;
                      }}
                    >
                      {location.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links & Sustainability */}
            <div className="footer-section" style={footerSectionStyle}>
              <h3 className="footer-section-title" style={responsiveStyles.title}>QUICK LINKS</h3>
              <ul style={footerLinksStyle}>
                {createLink("/", "Home")}
                {createLink("/residential", "Residential")}
                {createLink("/commercial", "Commercial & Industrial")}
                {createLink("/case-studies", "Case Studies")}
                {createLink("/media", "Media Gallery")}
              </ul>

              <h3 className="footer-section-title" style={{...responsiveStyles.title, marginTop: '30px'}}>SUSTAINABILITY</h3>
              <ul style={footerLinksStyle}>
                {createLink("/environment", "Environmental Compliance")}
                {createLink("/hse", "Health, Safety & Environment")}
                {createLink("/csr", "Corporate Social Responsibility")}
              </ul>
            </div>

            {/* Contact & Social */}
            <div className="footer-section" style={footerSectionStyle}>
              <h3 className="footer-section-title" style={responsiveStyles.title}>CONTACT US</h3>
              <div className="contact-info" style={contactInfoStyle}>
                <p className="contact-item" style={responsiveStyles.contact}>
                  <span style={{marginRight: '10px', fontWeight: '600', flexShrink: '0', color: colors.slate}}>📞</span> 
                  <span>+91 80879 32436</span>
                </p>
                <p className="contact-item" style={responsiveStyles.contact}>
                  <span style={{marginRight: '10px', fontWeight: '600', flexShrink: '0', color: colors.slate}}>✉️</span> 
                  <span>info@blueskyenergy.in</span>
                </p>
                <p className="contact-item" style={responsiveStyles.contact}>
                  <span style={{marginRight: '10px', fontWeight: '600', flexShrink: '0', color: colors.slate}}>🏢</span> 
                  <span>Plot.No 62A, Umred Rd, Satyam nagar, Dighori, Nagpur, Maharashtra 440034</span>
                </p>
                <p className="contact-item" style={responsiveStyles.contact}>
                  <span style={{marginRight: '10px', fontWeight: '600', flexShrink: '0', color: colors.slate}}>⏰</span> 
                  <span>Mon-Sun: 9:00 AM - 7:00 PM</span>
                </p>
              </div>

              <h3 className="footer-section-title" style={{...responsiveStyles.title, marginTop: '30px'}}>FOLLOW US</h3>
              <div className="social-icons" style={{
                display: 'flex', 
                gap: '12px', 
                marginTop: '15px', 
                flexWrap: 'wrap',
                justifyContent: responsiveStyles.social?.justifyContent || 'flex-start'
              }}>
                {['𝕏', 'f', 'in', '📷', '🎬'].map((icon, index) => (
                  <a 
                    key={index}
                    href="#" 
                    className="social-icon"
                    style={socialIconStyle}
                    onMouseEnter={(e) => {
                      e.target.style.color = socialHoverStyle.color;
                      e.target.style.transform = socialHoverStyle.transform;
                      e.target.style.backgroundColor = socialHoverStyle.backgroundColor;
                      e.target.style.opacity = socialHoverStyle.opacity;
                      e.target.style.boxShadow = socialHoverStyle.boxShadow;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = socialIconStyle.color;
                      e.target.style.transform = 'none';
                      e.target.style.backgroundColor = socialIconStyle.backgroundColor;
                      e.target.style.opacity = socialIconStyle.opacity;
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    {icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="footer-bottom" style={footerBottomStyle}>
            <p style={{
              fontWeight: '600', 
              margin: '0 0 15px 0',
              color: colors.frost,
              display: 'flex',
              justifyContent: 'center',
              gap: '20px',
              flexWrap: 'wrap'
            }}>
              <Link to="/legal" style={{color: colors.frost, textDecoration: 'none', opacity: '0.9'}}>Legal Disclaimer</Link>
              <span style={{color: colors.slate}}>|</span>
              <Link to="/privacy" style={{color: colors.frost, textDecoration: 'none', opacity: '0.9'}}>Privacy Policy</Link>
              <span style={{color: colors.slate}}>|</span>
              <Link to="/terms" style={{color: colors.frost, textDecoration: 'none', opacity: '0.9'}}>Terms of Use</Link>
            </p>
            <p style={{
              margin: '10px 0', 
              fontSize: '13px', 
              fontWeight: '500',
              color: colors.frost,
              opacity: '0.8'
            }}>
              Blue Sky Energy - Solar Panel Installation in Nagpur | Maharashtra Solar Solutions
            </p>
            <p style={{
              margin: '15px 0 0', 
              fontSize: '14px', 
              fontWeight: '600',
              color: colors.white,
              borderTop: `1px solid ${colors.midnight}`,
              paddingTop: '15px'
            }}>
              Copyright © 2025 KARMIC NEXUS IOT & IT COMPANY
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;